<i18n>
{
  "en": {
    "qrPreviewTitle": "QR codes from {0}",
    "downloadQRTooltip": "Download",
    "downloadAllQRTooltip": "Download all QRs"
  },
  "es": {
    "qrPreviewTitle": "Códigos QR {0}",
    "downloadQRTooltip": "Descargar",
    "downloadAllQRTooltip": "Descargar todos los QRs"
  }
}
</i18n>

<template>
  <div>
    <v-dialog @click:outside="onCancel" v-model="visible" max-width="600px" scrollable persistent>
      <v-card max-height="450" class="px-7 py-5" elevation="0">
        <div class="d-flex align-center justify-center mb-2">
          <v-card-title class="d-flex flex-row word-break pa-0">
            {{ $t('qrPreviewTitle', [saleZone.name]) }}
            <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon class="plus-icon mr-0" v-on="on" v-bind="attrs" @click="onDownloadAllQR">
                      <v-icon color="grey">mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('downloadAllQRTooltip') }}</span>
                </v-tooltip>
          </v-card-title>
        </div>
        <v-container class="pa-0">
          <v-form class="d-flex flex-row flex-wrap justify-center" ref="form">
            <div v-for="location in locationsToShow" :key="location.guid"
                 class="d-flex flex-column justify-center align-center mb-4">
              <div class="d-flex flex-row mb-n2">
                <span class="align-self-center">{{getLocationName(location)}}</span>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon class="plus-icon mr-0" v-on="on" v-bind="attrs" @click="onDownloadQR(location)">
                      <v-icon color="grey">mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('downloadQRTooltip') }}</span>
                </v-tooltip>
              </div>
              <v-img :src="location.qrCode" :alt="getLocationName(location)" contain width="135"/>
            </div>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Components } from '@core/helpers/decorators';
import { SaleZone } from '@dynameat/views/pointOfSale/models';
import DynameatModalButtons from '@dynameat/components/DynameatModalButtons.vue';
import { saveAs } from 'file-saver';

@Component
@Components({ DynameatModalButtons })
export default class MasterSaleZoneModal extends Vue {
  @Prop({ Object, validator(saleZone) { return saleZone instanceof SaleZone; } }) saleZone;

  @Prop({ type: Boolean, default: false }) visible;

  get locationsToShow() {
    const saleLocations = this.saleZone.saleLocations.filter((saleLocation) => !!saleLocation.qrCode);
    if (this.saleZone.qrCode) {
      saleLocations.splice(0, 0, this.saleZone);
    }
    return [...saleLocations];
  }

  getLocationName(location) {
    if (location.hasOwnProperty('name')) return location.name;
    return location.externalId;
  }

  onCancel() {
    this.$emit('close');
  }

  onDownloadQR(location) {
    const fileName = location.qrCode.split('/').at(-1);
    saveAs(location.qrCode, fileName);
  }

  onDownloadAllQR() {
    this.$emit('download-sale-zone-qrs', this.saleZone);
  }
}
</script>
